import { h, render, Component } from 'preact';
import { Wizard } from '../wizard';

export class InfoAppActivate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activationBarcodeURL: '',
      activationURL: '',
      status: 'waiting'
    }
    
  }

  componentDidMount() {
    this.enroll();
  }

  enroll = () => {
    fetch(
      "/api/v1/enroll"
    ).then( resp => {
      return resp.json();
    }).then( data => {
      this.setState((prevState, props) => ({
        activationBarcodeURL: data.barcode,
        activationURL: data.code
      }));
      this.poll_enroll_status();
    });
  }

  poll_enroll_status = () => {
    var me = this;
    setTimeout(function() {
      me.fetch_enroll_status()
        .then( data => {
          if(data.response != "waiting") {
            me.setState({status: data.response})
          } else {
            me.poll_enroll_status();
          }
        });
    }, 3000);
  }

  fetch_enroll_status = () => {
    return fetch(
      "/api/v1/enroll/status"
    ).then( resp => {
      return resp.json();
    });
  }

  render(props, state) {
		return (
      <Wizard isPanel="true"
        title={"Activate Duo Mobile for "+(props.deviceOS=="ios"?'iOS':'Android')}
        next={{callback: props.next, disabled: state.status != 'success'}}
        prev={state.status == 'waiting'?{callback: props.prev}:{}}>
        <div style="display:flex;align-items:center;font-size:1.1em;text-align:left;position:relative;">
          <img src={state.activationBarcodeURL} style="min-width:8em;height:8em;margin-right:1.5em;"/>
          {state.status == 'success' &&
          <div style="position:absolute;background:rgba(255,255,255,0.75);width:8em;height:8em;">
            <i class="fa fa-check-square fa-3x" style="color:#00A19B;background:white;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);"></i>
          </div>}
          {state.status == 'success' &&
          <p style="margin-top:0;text-align:left;">
            Your device has been successfully activated! You may click continue to log in.
          </p>}
          {state.status == 'waiting' &&
          <div>
            <ol>
              <li>Open Duo Mobile</li>
              <li>Tap the "+" icon</li>
              <li>Scan this barcode</li>
            </ol>
            If you are viewing this page using the device you want to activate, you can <a style="text-decoration:underline;" href={state.activationURL}>click here to activate</a> instead.
          </div>}
        </div>
      </Wizard>
		)
  }
}
